export default __webpack_public_path__ + "static/media/loginbanner.235ed424.png";